$(document).ready(function(){  
const randomFun = () => {
  const product_desc = document.querySelector('.product-decs-panel-first');
  if(product_desc) {
    product_desc.style.display = "block";
  }
}

window.onload = randomFun();
var ProductDecacc = document.getElementsByClassName("product-decs-accordion");
var i;
for (i = 0; i < ProductDecacc.length; i++) {
  ProductDecacc[i].addEventListener("click", function() {
    const isActive = this.classList.contains("active");

    for (const item of ProductDecacc) {
      item.classList.remove("active");
      item.nextElementSibling.style.display = "none";
    }
    if (!isActive) {
      this.classList.add("active");
      var panel = this.nextElementSibling;
      panel.style.display = "block";
    }
  });
}	
});